/**
 * Safe InstantSearch routing config that guards against non-object values
 * in URL state. The default `simple` stateMapping from instantsearch.js
 * uses _objectWithoutProperties (via SWC helpers in the ESM build), which
 * calls Reflect.ownKeys — this crashes on non-object primitives like
 * booleans or numbers that can appear in parsed query strings.
 *
 * CRA's webpack used the CJS build with Babel helpers that didn't crash;
 * Vite uses the ESM build with SWC helpers that do.
 */

function getIndexStateWithoutConfigure(uiState) {
  if (!uiState || typeof uiState !== "object") return {};
  const { configure, ...trackedUiState } = uiState;
  return trackedUiState;
}

export const safeRouting = {
  stateMapping: {
    stateToRoute(uiState) {
      return Object.keys(uiState || {}).reduce((state, indexId) => {
        return {
          ...state,
          [indexId]: getIndexStateWithoutConfigure(uiState[indexId]),
        };
      }, {});
    },
    routeToState(routeState) {
      return Object.keys(routeState || {}).reduce((state, indexId) => {
        return {
          ...state,
          [indexId]: getIndexStateWithoutConfigure(routeState[indexId]),
        };
      }, {});
    },
  },
};
